export default {
	methods: {
		openModal (item = null, confirmUrl = null) {
			this.$store.commit('microcourseModal/open')
			this.$store.commit('microcourseModal/setCourse', item)
			this.$store.commit('microcourseModal/setConfirmUrl', confirmUrl)
		},

		closeModal () {
			this.$store.commit('microcourseModal/close')
			this.$store.commit('microcourseModal/clearConfirmUrl')
			this.$store.commit('microcourseModal/clearCourse')
		}
	}
}
